import React, { Fragment, useEffect } from "react";
import { gql, useQuery } from "urql";
import { Base64 } from "js-base64";
import { saveAs } from "file-saver";

import { Button } from "../../../../components/src/Button";

const EXPORT_TACCOUNTS = gql`
    query tAccountChartAccountsExport($id: GraphQLObjectId!) {
        tAccountChartAccountsExport(_id: $id)
    }
`;

interface IExportTAccountChartAccountsButton {
    tAccountChartId: string;
    className: string;
    children?: string | React.ReactElement;
}

export const ExportTAccountChartAccountsButton = ({
    tAccountChartId,
    className = "btn-sm",
    children
}: IExportTAccountChartAccountsButton): React.ReactElement => {
    const [{ data }, refetch] = useQuery({
        query: EXPORT_TACCOUNTS,
        requestPolicy: "network-only",
        variables: { id: tAccountChartId },
        pause: true
    });

    useEffect(() => {
        if (data && data.tAccountChartAccountsExport) {
            saveAs(
                "data:text/csv;charset=utf-8;base64," + Base64.encode(data.tAccountChartAccountsExport),
                `export-${tAccountChartId}-taccounts.csv`
            );
        }
    }, [data, tAccountChartId]);

    return (
        <Fragment>
            <Button
                type="button"
                variant="primary"
                size="sm"
                className={className === "btn-sm" ? "" : className}
                onClick={async () => {
                    refetch();
                }}
            >
                {children}
            </Button>
        </Fragment>
    );
};
